import React from "react";
import ExcelImage from "./ExcelImage";
import ExcelChart from "./ExcelChart";
import "./Overlays.css";

/**
 * VisualOverlay
 * Absolutely-positioned layer that sits on top of the grid and renders
 * embedded images and charts.  The overlay is keyed on the active sheet
 * so children fully unmount/remount when the user switches sheets.
 */
function VisualOverlay({ activeSheet, sheetImages, sheetCharts, colWidths, rowHeights, zoomScale, hiddenCols, hiddenRows }) {
  return (
    <div
      key={activeSheet}
      className="excel-visual-content-overlay"
      style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none", zoom: zoomScale }}
    >
      {sheetImages.map((image, index) => (
        <div key={`image-${index}`} style={{ pointerEvents: "auto" }}>
          <ExcelImage image={image} colWidths={colWidths} rowHeights={rowHeights} zoomScale={1} hiddenCols={hiddenCols} hiddenRows={hiddenRows} />
        </div>
      ))}
      {sheetCharts.map((chart, index) => (
        <div key={`chart-${index}`} style={{ pointerEvents: "auto" }}>
          <ExcelChart chart={chart} colWidths={colWidths} rowHeights={rowHeights} zoomScale={1} hiddenCols={hiddenCols} hiddenRows={hiddenRows} />
        </div>
      ))}
    </div>
  );
}

export default React.memo(VisualOverlay);
